import gql from 'graphql-tag'

export const NOTIFY_ADD_TO_CART = gql`
  mutation NotifyAddToCart($ticket: String!) {
    notifyAddToCart(ticket: $ticket)
  }
`
